// extracted by mini-css-extract-plugin
export default {"modal":"components-settings-budget-forecast-upload-download-modal-module__modal"};